module.exports = __webpack_public_path__ + "img/60c47a53c44f29.38290043.2012cfc3.png";